import * as yup from "yup";

export const backgroundPatternSchema = yup.object().shape({
  title: yup.string().required("Title is required"),
  
  image: yup.string().required("Image is required"),
});
